import React from 'react'
import Stepper from '../../Stepper'
import TrashCanIcon from '../../../../Assets/Images/icons/newIcons/trashCanIcon'
import ArrowIcon from '../../../../Assets/Images/icons/newIcons/arrowIcon'
import { Col, Row } from 'react-bootstrap'
import { styles } from './styles'

const renderCell = (
  id,
  fieldName,
  value,
  onCellEdit,
  onRowDelete,
  headers,
  isEdit,
  onRowOpen = () => {},
) => {
  const field = headers.find(h => h.key === fieldName)
  switch (fieldName) {
    case 'date':
      return (
        <Col xs={field.xs} style={styles.dateColumn}>
          {value.replace(/-/g, '.').toUpperCase()}
        </Col>
      )
    case 'morningMissions':
      return (
        <Col xs={field.xs} style={styles.missionColumn}>
          {isEdit ? (
            <Stepper
              value={value}
              onAdd={() =>
                onCellEdit(
                  id,
                  fieldName,
                  Number(value) === 99 ? 99 : Number(value) + 1,
                )
              }
              onSubstract={() =>
                onCellEdit(
                  id,
                  fieldName,
                  Number(value) === 0 ? 0 : Number(value) - 1,
                )
              }
              onChange={value => {
                const val = Number(value)
                const clamped = Math.min(Math.max(val, 0), 99)
                onCellEdit(id, fieldName, clamped)
              }}
            />
          ) : (
            value
          )}
        </Col>
      )
    case 'lunchMissions':
      return (
        <Col xs={field.xs} style={styles.missionColumn}>
          {isEdit ? (
            <Stepper
              value={value}
              onAdd={() =>
                onCellEdit(
                  id,
                  fieldName,
                  Number(value) === 99 ? 99 : Number(value) + 1,
                )
              }
              onSubstract={() =>
                onCellEdit(
                  id,
                  fieldName,
                  Number(value) === 0 ? 0 : Number(value) - 1,
                )
              }
              onChange={value => {
                const val = Number(value)
                const clamped = Math.min(Math.max(val, 0), 99)
                onCellEdit(id, fieldName, clamped)
              }}
            />
          ) : (
            value
          )}
        </Col>
      )
    case 'afternoonMissions':
      return (
        <Col xs={field.xs} style={styles.missionColumn}>
          {isEdit ? (
            <Stepper
              value={value}
              onAdd={() =>
                onCellEdit(
                  id,
                  fieldName,
                  Number(value) === 99 ? 99 : Number(value) + 1,
                )
              }
              onSubstract={() =>
                onCellEdit(
                  id,
                  fieldName,
                  Number(value) === 0 ? 0 : Number(value) - 1,
                )
              }
              onChange={value => {
                const val = Number(value)
                const clamped = Math.min(Math.max(val, 0), 99)
                onCellEdit(id, fieldName, clamped)
              }}
            />
          ) : (
            value
          )}
        </Col>
      )
    case 'deleteButton':
      return (
        <Col xs={field.xs} style={styles.buttonColumn}>
          <button onClick={() => onRowDelete(id)} style={styles.deleteButton}>
            <TrashCanIcon />
          </button>
        </Col>
      )

    case 'details':
      return (
        <Col xs={field.xs} style={styles.buttonColumn}>
          <button onClick={() => onRowOpen(id)} style={styles.arrowButton}>
            <ArrowIcon position="bottom" />
          </button>
        </Col>
      )
    case 'id':
      return null
    default:
      return null
  }
}

const TableRow = ({
  data,
  onCellEdit,
  onRowDelete,
  headers,
  isEdit = false,
}) => {
  return (
    <Row style={styles.row}>
      {Object.keys(data).map(key => {
        return renderCell(
          data.id,
          key,
          data[key],
          onCellEdit,
          onRowDelete,
          headers,
          isEdit,
        )
      })}
    </Row>
  )
}

export default TableRow
